import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    position: 'relative',
    marginBottom: ({ offset }) => `${offset}px`,
  },
  overlay: {
    background: 'linear-gradient(rgba(0, 35, 75, 0.7), rgba(0, 35, 75, 0.7))',
    overflow: 'hidden',
    height: '100%',
    width: '100%',
    zIndex: '2',
    display: ({ showHeroBackgroundOverlay }) => (showHeroBackgroundOverlay ? 'flex' : 'none'),
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      display: ({ showHeroBackgroundOverlay }) => (showHeroBackgroundOverlay ? 'block' : 'none'),
    },
  },
  imageContainer: ({ images }) => ({
    position: 'relative',
    backgroundImage: images && `url(${images.lg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    height: '60vh',
    [theme.breakpoints.down('xs')]: {
      height: '50vh',
      backgroundImage: images && `url(${images.sm})`,
    },
  }),
  videoContainer: {
    objectFit: 'cover',
    width: '100%',
    height: '70vh',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      height: '60vh',
    },
  },
  buttonContainer: {
    position: 'absolute',
    left: '35px',
    bottom: '20px',
    display: 'flex',
    '&>button:nth-child(1)': {
      marginRight: theme.spacing(1),
      paddingLeft: '10px',
    },
    [theme.breakpoints.down('sm')]: {
      left: 'auto',
      bottom: '330px',
      right: '16px',
    },
  },
  videoButton: {
    backgroundColor: theme.palette.secondary.dark,
    padding: '10px',
    paddingLeft: '15px',
    height: '42px',
    width: '42px',
    border: 'none',
    '&:focus': {
      outline: '3px solid white',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  ctaContainer: {
    [theme.breakpoints.only('xs')]: {
      '& span': {
        fontSize: '0.75rem',
      },
    },
  },
  heroContent: {
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    height: '100%',
    padding: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
    '& .rich-paragraph': {
      textAlign: 'center',
    },
  },
  heroSummary: {
    maxWidth: '800px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },
  },
  quickLinksRoot: {
    position: 'absolute',
    bottom: ({ offset }) => `-${offset}px`,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  quickLinksWrapper: {
    color: theme.palette.common.white,
    width: '80%',
    backgroundColor: theme.palette.secondary.dark,
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(2),
    },
  },
  quickLinksList: {
    position: 'relative',
    '&:before': {
      content: '""',
      height: '100%',
      width: '1px',
      backgroundColor: theme.palette.grey.light,
      opacity: '0.5',
      position: 'absolute',
      left: '-2rem',
    },
  },
}))
